export default __webpack_public_path__ + "static/media/glasshouse_environment_c.31929353.mp4";